const durations = [
  {
    value: 1,
    label: '2-4 weeks',
  },
  {
    value: 2,
    label: '4-6 weeks',
  },
  {
    value: 3,
    label: '6-8 weeks',
  },
  {
    value: 4,
    label: '2-3 months',
  },
  {
    value: 5,
    label: '3-4 months',
  },
  {
    value: 6,
    label: '5-6 months',
  },
  {
    value: 7,
    label: 'Ongoing',
  },
];

export default durations;
